import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const compass: ISVGPersonalProps = {
  viewBox: '0 0 32 32',
  content: (
    <g>
      <path
        clipRule="evenodd"
        d="M25.221 7.48l-6.192 10.436-4.242-4.243 10.434-6.193z"
        fill="#E2574C"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.594 24.11l10.435-6.193-4.242-4.243-6.193 10.436z"
        fill="#E4E7E7"
        fillRule="evenodd"
      />
    </g>
  ),
};
